<template>
	<div class="counter g-2 text-high">
		<div class="counter__status bg-medium-active radius-small px-1 py-2">
			{{ countdown.days }}
			{{ countdown.days == 1 ? $t('WEBAPP_ABBREV_DAY') : $t('WEBAPP_ABBREV_DAYS') }}
		</div>

		<div class="counter__status bg-medium-active radius-small px-1 py-2">
			{{ countdown.hours }}
			{{ countdown.hours == 1 ? $t('WEBAPP_ABBREV_HOUR_HR') : $t('WEBAPP_ABBREV_HOURS_HRS') }}
		</div>

		<div class="counter__status bg-medium-active radius-small px-1 py-2">
			{{ countdown.minutes }}
			{{ countdown.minutes == 1 ? $t('WEBAPP_ABBREV_MINUTE_MIN') : $t('WEBAPP_ABBREV_MINUTES_MINS') }}
		</div>

		<div class="counter__status bg-medium-active radius-small px-1 py-2">
			{{ countdown.seconds }}
			{{ countdown.seconds == 1 ? $t('WEBAPP_ABBREV_SECOND_SEC') : $t('WEBAPP_ABBREV_SECONDS_SECS') }}
		</div>
	</div>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';

interface Countdown {
	days: number;
	hours: number;
	minutes: number;
	seconds: number;
}

const props = defineProps<{
	dateTime: Date;
}>();

const emptyCountdown: Countdown = {
	days: 0,
	hours: 0,
	minutes: 0,
	seconds: 0,
};

let interval: number | NodeJS.Timeout | null = null;
const countdown = ref<Countdown>({ ...emptyCountdown });

// const timestamp = '2024-11-12T23:11:00+01:00';

onMounted((): void => {
	calculateCountdown();
	interval = setInterval(calculateCountdown, 1000);
});

onBeforeUnmount((): void => {
	if (interval !== null) clearInterval(interval as number);
});

const calculateCountdown = (): void => {
	const now: Date = new Date();
	const eventDate: Date = new Date(props.dateTime);
	const timeDiff: number = eventDate.getTime() - now.getTime();

	if (timeDiff > 0) {
		countdown.value.days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
		countdown.value.hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
		countdown.value.minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
		countdown.value.seconds = Math.floor((timeDiff / 1000) % 60);
	} else {
		// Clear interval when countdown ends
		clearInterval(interval as number);

		// Set the values to 0
		countdown.value = { ...emptyCountdown };
	}
};
</script>

<style lang="scss" scoped>
.counter {
	display: flex;

	&__status {
		font-weight: 400;
		font-size: 14px;
		text-transform: uppercase;
	}
}
</style>
